import React from 'react';
import { connect } from 'react-redux';
import ShowMoreText from 'react-show-more-text';

import { STATIC_ROOT } from '../../../../constants';

import { copy } from '../../../../utils/copyToClipboardUtils';
import { getEndDateFormat } from '../../../../services/coupon/utils';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import SvgComponent from '../../../SvgComponent';
import ButtonComponent from '../../../button/ButtonComponent';

import './CouponOfferComponent.scss';

const LIMIT_LINES_DESCRIPTION = 4;

class CouponOfferComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            copied: false
        };
    }

    onClickCopy = e => {
        const { coupon } = this.props;
        const { copied } = this.state;

        if (!copied) {
            copy(coupon.code);
            this.setState({ copied: true });
        }
    };

    renderButtonContent = () => {
        const { coupon } = this.props;
        const { copied } = this.state;

        let urlSvg = null;
        if (copied) {
            urlSvg = `${STATIC_ROOT}/check.svg`;
        } else {
            urlSvg = `${STATIC_ROOT}/copypaste.svg`;
        }
        return (
            <span className="bt-text flex-container-h flex-center-alt">
                <span>{coupon.code}</span>
                <SvgComponent src={urlSvg} className="svg-container" width="17" height="20" />
            </span>
        );
    };

    renderConditionalButtonCopyCoupon = () => {
        const { coupon } = this.props;
        if (coupon && coupon.code && coupon.code.trim().length > 0) {
            return (
                <p className="w100 txtcenter">
                    <ButtonComponent
                        type="button"
                        color="fifth"
                        text={this.renderButtonContent()}
                        onClick={this.onClickCopy}
                        cssClass="w100"
                    />
                </p>
            );
        }
    };

    renderConditionalTextCopyCoupon = () => {
        const { coupon } = this.props;
        if (coupon && coupon.code && coupon.code.trim().length > 0) {
            if (this.state.copied) {
                return <p className="small">{this.props.i18n.page.INTERSTITIEL.COPIED_COPY}</p>;
            } else {
                return (
                    <p>
                        <small className="underline curpt" onClick={this.onClickCopy}>
                            {this.props.i18n.page.INTERSTITIEL.COPY_THE_CODE}
                        </small>
                    </p>
                );
            }
        }
    };

    render() {
        const { partner, coupon, i18n } = this.props;
        if (partner && coupon) {
            return (
                <div className="offer-coupon flex-container-v flex-center">
                    <div className="bold txtcenter">
                        <ShowMoreText lines={LIMIT_LINES_DESCRIPTION} more="" less="">
                            {convertHtmlToReactDomWithParams(coupon.description)}
                        </ShowMoreText>
                    </div>
                    <p className="validite">
                        <small>{getEndDateFormat(coupon.endDate, i18n)}</small>
                    </p>
                    {this.renderConditionalButtonCopyCoupon()}
                    {this.renderConditionalTextCopyCoupon()}
                </div>
            );
        }
        return null;
    }
}

export default connect(state => ({ i18n: state.i18n }))(CouponOfferComponent);



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/offer/CouponOfferComponent.js